// extracted by mini-css-extract-plugin
export var attachmentContainer = "_mj-0";
export var fileList = "_mj-2";
export var removeFileButton = "_mj-1";